import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  runOutOfPlaceRestore(targetVdcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + targetVdcId + '/restore';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res: any) => this.value = res
      );
  }

  getRestoreTargetVDCs(vdcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/restoreTargetVdcs';
    return this.http
      .get(url)
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/out-of-place-restore/out-of-place-restore.service.ts